import { render } from "./PushNotificationServiceParameter.vue?vue&type=template&id=4e633ee5&scoped=true"
import script from "./PushNotificationServiceParameter.vue?vue&type=script&lang=ts"
export * from "./PushNotificationServiceParameter.vue?vue&type=script&lang=ts"

import "./PushNotificationServiceParameter.vue?vue&type=style&index=0&id=4e633ee5&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-4e633ee5"

export default script